import { get, reduce } from 'lodash'

const sumUpModifiers = (modifiers) =>
  reduce(
    modifiers,
    (acc, modifierItem) => {
      const priceInCents = get(modifierItem, 'defaultPriceInCents', 0)
      return acc + priceInCents
    },
    0,
  )

export default sumUpModifiers
